module.exports = __webpack_public_path__ + "img/symbol_13_x25.b8bded84.png";